/**
 * The time zones on offer, in one place.
 *
 * `Intl.supportedValuesOf` where the browser has it — four hundred names is a
 * long menu but it is the true list, and a company with a branch in Phoenix
 * needs Phoenix. The fallback is the handful of North American zones, because
 * a field that cannot be set at all is worse than one that is short.
 *
 * Lifted out of `components/org/org-detail.tsx` when Rowted Admin's New client
 * flyout needed the same field: two copies of a list like this drift the day
 * one of them gains a fallback the other has not got.
 */
export const TIMEZONES: string[] = (() => {
  try {
    const supported = (Intl as unknown as {
      supportedValuesOf?: (key: string) => string[]
    }).supportedValuesOf
    if (supported) return supported('timeZone')
  } catch { /* older browsers, and anywhere the call throws */ }
  return [
    'America/New_York', 'America/Chicago', 'America/Denver', 'America/Phoenix',
    'America/Los_Angeles', 'America/Anchorage', 'Pacific/Honolulu',
  ]
})()
